import { IState, useMainStore } from "@/settings/zustand"
import { ID, IMenuItem } from "@libs/interfaces/layouts"
import { template } from "@libs/layouts"
import { __ } from "@libs/utilities"
import { useEffect, useState } from "react"
import { NavLink, } from "react-router-dom" 
import { isRouteOpen } from "../utils/isRouteOpen"
import { LayoutIcon } from "src/libs/useful"

/* Protopia Ecosystem component */
export interface IFooterMenuItemProps {
    item: IMenuItem
}
const FooterMenuItem = ({item}: IFooterMenuItemProps): JSX.Element => {    
    const landId:ID             = useMainStore( ( state: IState ) => state.landId )
    const event_types: string[] =  useMainStore( ( state: IState ) => state.event_types ) || [] 
    const [isOpen, setIsOpen]   = useState<boolean>(isRouteOpen(item, landId, event_types))
    useEffect(() => {
        setIsOpen( isRouteOpen(item, landId, event_types) )
    }, [ item, landId, event_types ])
    return <div className='pe-footer-menu-item-container ' data-testid="layout-footer-menu-btn">
        <NavLink
            to={item.route} 
            className={` hover small  ${ isOpen ? "opened" : "closed" }`}
        >
            <div 
                className="d-flex "
                style={{
                    color: `${template().footer?.color}`
                }}
            >
                <LayoutIcon
                    src={ item.icon || ""}
                    className="header-menu-icon" 
                />
                { __(item.title) }
            </div>
        </NavLink>
    </div>
}
export default FooterMenuItem